export default __webpack_public_path__ + "static/media/najir.f5906229.png";